import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {ListItem, withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import LoadingButton from "../../../components/elements/LoadingButton";

import EditRoundedIcon from "@material-ui/icons/EditRounded";
import TextField from "@material-ui/core/TextField/TextField";
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import GetConfirmationButton from "../../../components/elements/GetConfirmationButton";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import PowerSettingsNewRoundedIcon from "@material-ui/icons/PowerSettingsNewRounded";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
class ExcelImportButton extends React.Component{
    state = {
        SubmitLoading:false,
        loading:false,
        open:false,
        product_id:this.props.id,
        errors:[],
    };
    toggleOpen(){
        this.setState({
            open: !this.state.open,
        })
    }
    handleRequest(){
        this.setState({
            SubmitLoading:true
        })
        const {product_id} = this.state;
        let data = new FormData();
        data.append('id', product_id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/product/remove_isbn`, data, config)
            .then(response => {
                if(response.data === "ok"){
                    this.props.enqueueSnackbar(Translate.allChangesSaved, {
                        variant: 'success',
                    });
                    this.setState({
                        SubmitLoading:false,
                        open:false
                    });
                    this.props.reload()
                }else{
                    this.props.enqueueSnackbar(Translate.isbnIsExistHead, {
                        variant: 'warning',
                    });
                    this.setState({
                        SubmitLoading:false,
                    });
                }

            })
            .catch(error => {
                console.log(error.response)
                if(error.response.status === 404){
                    this.props.enqueueSnackbar(Translate.isbnIsExistHead, {
                        variant: 'warning',
                    });
                }else{
                    this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                        variant: 'error',
                    });
                }

                this.setState({
                    errors:error.response.data,
                    SubmitLoading:false
                });
            });
    }

    render(){
        let {SubmitLoading,open,fields,errors} = this.state;
        return (
            <>
                <GetConfirmationButton
                    handleAction={() => this.handleRequest()}
                    question={Translate.doYouWanaRISBN}
                    icon={<CheckBoxIcon/>}
                    size="small"
                    tooltip={Translate.removeISBN}
                >
                    {
                        !SubmitLoading ?
                            <HighlightOffRoundedIcon style={{color:"#c96a6a"}} fontSize="small"/>
                            :
                            <CircularProgress size={20}/>
                    }
                </GetConfirmationButton>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ExcelImportButton)))));